import { Key } from '@briebug/ngrx-auto-entity';

export class MaterialCategory {
  @Key id?: number;
  name: string;
  delta: number;
}
